import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";

const HeroSectionData: HeroSectionProps = {
    title: "Transform traveler experiences with WhatsApp automation",
    listHeading:
        "Modern travelers are mobile-first, always connected, and expect fast, personalized service. Traditional communication methods aren’t cutting it anymore. This free eBook shows how travel and tourism brands are using WhatsApp to simplify booking, support, and sales — while delivering 5-star experiences at scale.",
    listText: [
        {
            label: "Learn how to use WhatsApp automation from the first inquiry to post-trip loyalty — including instant quotes, booking confirmations, live itinerary updates, and feedback collection.",
        },
        {
            label: "Discover how automated replies, multilingual support, and payment reminders help travel businesses respond faster and close more bookings without additional headcount.",
        },
        { label: "Explore WhatsApp Business API strategies that allow even small teams to deliver real-time, high-touch service — whether you're managing 10 trips or 10,000." },
    ],

    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/travel.png",
    altMedia: "gallabox-e-book",
    ebookName: "travel",
};

const EBookWhyWhatsappForBusiness: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Automation for Travel Companies - Gallabox eBooks"
            description=" Learn how top travel companies use WhatsApp automation solutions to deliver exceptional travel experiences for their customers. Download the ebook now"
            canonical="https://gallabox.com/resources/whatsapp-for-travel-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/travel-og.png" }}
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">Trusted by over 2,000 companies across 40+ countries</h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBookWhyWhatsappForBusiness;
